export default "__VITE_ASSET__XchcL4_x__"